import React from 'react';
import i18n from 'i18n-js';
// const verisignSecure = require('../../assets/images/verisign_secure.gif');

import verisignSecure from '../../assets/images/verisign_secure.gif';
import mastercardSecurecode from '../../assets/images/mastercard_securecode.gif';
import nets from '../../assets/images/nets.png';
import dankort from '../../assets/images/dankort.gif';
import visa from '../../assets/images/visa.gif';
import mastercard from '../../assets/images/mastercard.gif';
import diners from '../../assets/images/diners.gif';
import mobilepay from '../../assets/images/mobilepay.png';

const FormOfPayment = (props: any) => {
  const { changeCheckoutForm, checkoutIndex, submitBooking } = props;

  const cssWrapper = checkoutIndex === 3 ? 'box-wrapper show' : 'box-wrapper hide';

  return (
    <div className="box-form-of-payment box-form">
      <div className="box-wrapper">
        <p>
          <b>{i18n.t('cardPayment')}</b>
          <br />
          <br />
          {i18n.t('cardPaymentNote')}
        </p>
        <div className="box-cards-1">
          <ul>
            <li><img src={verisignSecure} /></li>
            <li><img src={mastercardSecurecode} /></li>
            <li><img src={nets} /></li>
          </ul>
        </div>
        <p>{i18n.t('paymentMethod')}</p>
        <div className="box-cards-2">
          <ul>
            <li><img src={dankort} /></li>
            <li><img src={visa} /></li>
            <li><img src={mastercard} /></li>
            <li><img src={diners} /></li>
            <li><img src={mobilepay} /></li>
          </ul>
        </div>
        {
          // <div className="box-btn pd-bottom-20">
          //   <button className="red" onClick={() => submitBooking('submit')}>
          //     {i18n.t('executeOrder')}
          //   </button>
          // </div>
        }

        <div className="box-btn">
          <button className="white" onClick={props.onHide}>
            {i18n.t('cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

// <li><img src={verisignSecure} /></li>

export default FormOfPayment;
